import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1603"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m14.183 3.286-1.438.816-6.302 10.909h9.119z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M12.232 5.903 9.153 7.186l-4.865 7.825h7.809z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M9.149 8.653 4.566 9.809.903 15.011h7.809zm1.956-2.84a.713.713 0 1 0-1.155-.835.713.713 0 0 0 1.155.835z" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "M5.63 9.863a.825.825 0 1 0-1.339-.966.825.825 0 0 0 1.339.966zM3.835 7.438a.913.913 0 1 0-1.481-1.069.913.913 0 0 0 1.481 1.069zm8.678-4.778a1.149 1.149 0 1 0-1.862-1.346 1.149 1.149 0 0 0 1.862 1.346zm-4.239.906A1.149 1.149 0 1 0 6.409 2.22a1.149 1.149 0 1 0 1.865 1.346zm-.084 4.16a1.572 1.572 0 1 0-2.548-1.84 1.572 1.572 0 0 0 2.548 1.84zm-5.784 4.602a1.313 1.313 0 1 0-1.537 2.13 1.313 1.313 0 0 0 1.537-2.13z" }, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }